import React from 'react';
import { PermissionCode, useHasPermission } from '@/entities/profile';
import { NotFoundPage } from '@/pages/NotFoundPage';

export type PermissionRouteProps = {
  viewPermission?: PermissionCode | PermissionCode[];
  children: React.ReactNode;
};

export const PermissionRoute: React.FC<PermissionRouteProps> = ({ viewPermission, children }) => {
  const isAllowed = useHasPermission(viewPermission);

  if (viewPermission && !isAllowed) {
    return <NotFoundPage />;
  }

  return <>{children}</>;
};
